import { ConvertedFarm } from "./helpers";
import { Feature } from "geojson";
import { FeatureCollectionWithFilename } from "shpjs";

export interface ShpToGeojsonConvertRequest {
  type: "shp-convert-req";
  // the ArrayBuffer backing a File object that contains a .shp/.dbf file
  arrayBuffer: ArrayBuffer;
}

export type ShpToGeojsonConvertResponse =
  | {
      type: "shp-convert-resp";
      files: FeatureCollectionWithFilename[];
      error?: undefined;
    }
  | {
      type: "shp-convert-resp";
      files?: undefined;
      error: Error;
    };

export interface GeojsonToProtoConvertRequest {
  type: "proto-convert-req";
  /** a request ID used to discard outdated responses */
  requestId: number;
  /** the customer ID to bake into the farm protos */
  customerId: number;
  /** the list of geojson features to convert */
  inputFeatures: Feature[];
  /** the names of the properties that should be used to generate each farm's name field */
  farmNameTemplate: string[];
  /** the names of the properties that should be used to generate each field's name field */
  fieldNameTemplate: string[];
}

export type GeojsonToProtoConvertResponse =
  | {
      type: "proto-convert-resp";
      requestId: number;
      cvtFarms: ConvertedFarm[];
      error?: undefined;
    }
  | {
      type: "proto-convert-resp";
      requestId: number;
      cvtFarms?: undefined;
      error: Error;
    };

export enum ImportErrorCode {
  UnrecognizedGeometryType = 1,
}

export type ImportError = {
  code: ImportErrorCode.UnrecognizedGeometryType;
  type: string;
};

export type ShapefileImportWorkerRequest =
  | ShpToGeojsonConvertRequest
  | GeojsonToProtoConvertRequest;

export type ShapefileImportWorkerResponse =
  | ShpToGeojsonConvertResponse
  | GeojsonToProtoConvertResponse;
